import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useStyles } from "./Loading.styles";

const Loading = () => {
	const styles = useStyles();

	return (
		<div>
			<Box sx={{ paddingTop: "11rem", paddingBottom: "13rem", display: "flex", justifyContent: "center" }}>
				<CircularProgress className={styles.loadingStyle} />
			</Box>
		</div>
	);
};

export default Loading;
